import * as React from 'react';

import type { TAdBannerMicrofrontendParameters } from '../../types';

interface IAdBannerPlaceholderProps extends React.PropsWithChildren {
  sizes: TAdBannerMicrofrontendParameters['sizes'];
  testId: string;
}

/**
 * Резервирует место под рекламу, пока баннер грузится, чтобы не было сдвигов вёрстки (CLS).
 */
export const AdBannerPlaceholder: React.FC<IAdBannerPlaceholderProps> = ({ sizes, testId, children }) => {
  const { width, height } = sizes;

  return (
    <div data-testid={testId} style={{ width, height, minHeight: height }}>
      {children}
    </div>
  );
};
